class SphereControler {

    //
    //  SphereControler
    //  Eigen wrapper rondom sphere container, voor mobiel voornamelijk
    //

    constructor( sphereelement ) {
      this.version = 1.0;
      this.sphereelement = sphereelement;
      this.slide_category_dots = null;
      this.category = 'ambitie';

      this.slide_category_dots = document.querySelector('.slide-category__dots-fake');

      this.add_hooks();
      // this.slide_to( this.category );
    }

    add_hooks() {
      var self = this;
      jQuery('[href=#zoom]').on('click', function(e) {
        e.preventDefault();
        var category = this.getAttribute('slide-category');
        self.set( category );
      });
    }

    set( _category ) {
      var self = this;
      if( self.category == _category ) return;

      // dots
      if( self.slide_category_dots.classList.contains( self.category ) ) {
        self.slide_category_dots.classList.remove( self.category );
      }
      self.slide_category_dots.classList.add( _category );

      // container
      if( self.sphereelement.classList.contains( self.category ) ) {
        self.sphereelement.classList.remove( self.category );
      }
      self.sphereelement.classList.add( _category );

      self.category = _category;
    }

}